import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useFeatureFlagState } from "@/hooks/use-feature-flag";

interface Props {
  flag: string;
  /** Para onde vai quem abre a rota com a bandeira desligada. */
  fallback: string;
  children: ReactNode;
  loading?: ReactNode;
}

/**
 * Portão de rota por bandeira.
 *
 * `/planos-v2` e `/planos-v3` eram rotas abertas a qualquer logado — e o próprio
 * comentário de `PlanosV2` dizia "o portão é feito pelo roteador", sem que o
 * roteador tivesse portão nenhum. Com a bandeira desligada, quem digitasse o
 * endereço via uma escada de preços que o produto não oferece e cujos limites
 * o banco não aplica: "limite novo com tela velha" chega ao suporte como "o
 * sistema está com erro".
 *
 * Usa `useFeatureFlagState`: enquanto a bandeira não respondeu NÃO se redireciona
 * — pendente não é desligada (a mesma regra que fazia `/planos` piscar).
 */
export function FlagGate({ flag, fallback, children, loading = null }: Props) {
  const { enabled, carregando } = useFeatureFlagState(flag);
  if (carregando) return <>{loading}</>;
  if (!enabled) return <Navigate to={fallback} replace />;
  return <>{children}</>;
}
